import { render, staticRenderFns } from "./PolicyLimitsModal.vue?vue&type=template&id=07bc26e0&scoped=true"
import script from "./PolicyLimitsModal.vue?vue&type=script&lang=js"
export * from "./PolicyLimitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc26e0",
  null
  
)

export default component.exports